/* eslint-disable handle-callback-err */
import $ from 'jquery';
import Auth0Helpers from '../_helpers/auth0-helpers';
import PlayerFavorites from './player-favorites';
import {
  updateDeletedStarEvent,
  updateDeletedStarHeaderEvent,
  updateAddedStarEvent,
  updateAddedStarHeaderEvent,
  maxFavoriteModalClass,
  loginModalClass,
  addFavoriteButtonClass,
  removeFavoriteButtonClass,
  favoriteTooltipClass,
} from '../_helpers/constants';

export default class PlayerHeader {
  constructor(elm, opts) {
    this.$element = $(elm);
    this.opts = opts;
    this.auth0Helpers = new Auth0Helpers();
    this.addFavoritesText = this.opts.addFavoritesText;
    this.removeFavoritesText = this.opts.removeFavoritesText;
    this.playerFavorites = new PlayerFavorites('', {
      addFavoritesText: this.addFavoritesText,
      removeFavoritesText: this.removeFavoritesText,
    });
    this.addFavoriteButton = this.$element.find(addFavoriteButtonClass);
    this.removeFavoriteButton = this.$element.find(removeFavoriteButtonClass);
    this.userData = undefined;

    this.dataContainer = this.$element.parent()[0];

    this.maxfavoritesModal = null;
    this.loginModal = null;

    this.favoriteTooltip = this.$element.find(favoriteTooltipClass);
  }

  async loadUserData() {
    try {
      this.userData = await this.auth0Helpers.getUserFavoritesData();
    } catch (e) {}
  }

  async updateUI() {
    const self = this;
    if (this.userData && this.userData.favoriteplayers) {
      if (this.userData.favoriteplayers.length > 0) {
        this.userData.favoriteplayers.forEach((item) => {
          this.addStar(item, self);
        });
      } else {
        this.changeFavoriteTooltipText(this.favoriteTooltip, this.addFavoritesText);
      }
    } else {
      this.changeFavoriteTooltipText(this.favoriteTooltip, this.addFavoritesText);
    }
  }

  addStar(item, self) {
    const favorite = self.$element.find(`[data-id='${item}']`);

    const addButton = $(favorite).find(addFavoriteButtonClass);
    addButton.hide();
    const removeButton = $(favorite).find(removeFavoriteButtonClass);
    removeButton.show();

    const tooltip = favorite.find(favoriteTooltipClass);
    if (tooltip.length > 0) {
      this.changeFavoriteTooltipText(tooltip, this.removeFavoritesText);
    } else {
      this.changeFavoriteTooltipText(this.favoriteTooltip, this.addFavoritesText);
    }
  }

  removeStar(item, self) {
    const favorite = self.$element.find(`[data-id='${item}']`);

    const addButton = $(favorite).find(addFavoriteButtonClass);
    addButton.show();
    const removeButton = $(favorite).find(removeFavoriteButtonClass);
    removeButton.hide();

    const tooltip = favorite.find(favoriteTooltipClass);
    this.changeFavoriteTooltipText(tooltip, this.addFavoritesText);
  }

  async updateFunc() {
    await this.loadUserData();

    await this.updateUI();
  }

  changeFavoriteTooltipText(item, text) {
    item.html(text);
  }

  async init() {
    this.maxfavoritesModal = $(maxFavoriteModalClass);
    this.loginModal = $(loginModalClass);
    this.auth0Helpers.initModals();
    await this.updateFunc();

    const self = this;
    this.addFavoriteButton.on('click', async function () {
      const isAuthenticated = await self.auth0Helpers.isAuthenticated();

      if (isAuthenticated) {
        self.userData = await self.playerFavorites.addFavorite(
          this,
          $(this).parent(),
          updateAddedStarHeaderEvent,
          self.maxfavoritesModal,
          self.userData
        );
        self.changeFavoriteTooltipText(self.favoriteTooltip, self.removeFavoritesText);
      } else {
        $(self.loginModal).show();
      }
    });

    this.removeFavoriteButton.on('click', async function () {
      self.userData = await self.playerFavorites.removeFavorite(
        this,
        $(this).parent(),
        updateDeletedStarHeaderEvent,
        self.userData
      );
      self.changeFavoriteTooltipText(self.favoriteTooltip, self.addFavoritesText);
    });

    window.addEventListener(updateDeletedStarEvent, (e) => {
      if (e.detail && e.detail.id != null) {
        const id = e.detail.id;
        this.removeStar(id, self);
      }
    });

    window.addEventListener(updateAddedStarEvent, (e) => {
      if (e.detail && e.detail.id != null) {
        const id = e.detail.id;
        this.addStar(id, self);
      }
    });
  }
}
